import React, { useState } from 'react';
import {
  Box,
  Container,
  Heading,
  SimpleGrid,
  VStack,
  HStack,
  Image,
  Text,
  IconButton,
  useColorMode,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  useDisclosure,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FiPlus, FiPlay, FiMoreVertical } from 'react-icons/fi';

const MotionBox = motion(Box);

const Playlists = () => {
  const { colorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [playlists, setPlaylists] = useState([
    {
      id: 1,
      name: 'پلی‌لیست ۱',
      songCount: 12,
      cover: 'https://picsum.photos/300',
    },
    {
      id: 2,
      name: 'پلی‌لیست ۲',
      songCount: 8,
      cover: 'https://picsum.photos/301',
    },
    {
      id: 3,
      name: 'پلی‌لیست ۳',
      songCount: 15,
      cover: 'https://picsum.photos/302',
    },
  ]);

  const handleCreatePlaylist = (name) => {
    const newPlaylist = {
      id: playlists.length + 1,
      name,
      songCount: 0,
      cover: `https://picsum.photos/${300 + playlists.length}`,
    };
    setPlaylists([...playlists, newPlaylist]);
    onClose();
  };

  return (
    <Container maxW="container.xl" py={8}>
      <VStack spacing={8} align="stretch">
        <HStack justify="space-between">
          <Heading size="xl">پلی‌لیست‌ها</Heading>
          <Button
            leftIcon={<FiPlus />}
            colorScheme="brand"
            onClick={onOpen}
          >
            پلی‌لیست جدید
          </Button>
        </HStack>
        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={6}>
          {playlists.map((playlist, index) => (
            <MotionBox
              key={playlist.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              <Box
                bg={colorMode === 'dark' ? 'gray.700' : 'white'}
                borderRadius="xl"
                overflow="hidden"
                boxShadow="lg"
                position="relative"
                _hover={{ transform: 'translateY(-4px)' }}
                transition="transform 0.2s"
              >
                <Image
                  src={playlist.cover}
                  alt={playlist.name}
                  w="100%"
                  h="200px"
                  objectFit="cover"
                />
                <Box p={4}>
                  <Text fontWeight="bold" fontSize="lg">
                    {playlist.name}
                  </Text>
                  <Text color="gray.500">
                    {playlist.songCount} آهنگ
                  </Text>
                </Box>
                <Box
                  position="absolute"
                  top={2}
                  right={2}
                  display="flex"
                  gap={2}
                >
                  <IconButton
                    icon={<FiPlay />}
                    colorScheme="brand"
                    size="sm"
                    aria-label="Play playlist"
                  />
                  <IconButton
                    icon={<FiMoreVertical />}
                    variant="ghost"
                    size="sm"
                    aria-label="More options"
                  />
                </Box>
              </Box>
            </MotionBox>
          ))}
        </SimpleGrid>
      </VStack>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>ایجاد پلی‌لیست جدید</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel>نام پلی‌لیست</FormLabel>
              <Input
                placeholder="نام پلی‌لیست را وارد کنید"
                type='search'
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleCreatePlaylist(e.target.value);
                  }
                }}
              />
            </FormControl>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Container>
  );
};

export default Playlists; 